export const REDUCER_NAME = 'gmail'




// WEBPACK FOOTER //
// ./src/modules/gmail/state/const.js